import { Box, Skeleton } from '@chakra-ui/react';
import { forwardRef } from 'react';

const AuthBackgroundImage = forwardRef(function AuthBackgroundImage(
    { isLoading, ['aria-label']: ariaLabel = 'image', ...props },
    ref,
) {
    return isLoading ? (
        <Skeleton
            isLoaded={!isLoading}
            fadeDuration={1}
            flex={{ base: '0', md: '1' }}
            display={{ base: 'none', md: 'block' }}
            aria-label={ariaLabel}
            ref={ref}
        />
    ) : (
        <Box
            flex={{ base: '0', md: '1' }}
            display={{ base: 'none', md: 'block' }}
            aria-label={ariaLabel}
            ref={ref}
            {...props}
        />
    );
});

export { AuthBackgroundImage };
